// components
import {
    PageTable,
    ChargebackComponents,
    ViewDownloadGeneric,
    Popup,
    FormElems,
} from 'components';

import happyFaceImage from 'static/images/happyFace.svg';

// styles
import './chargebackPage.scss';

// constant
import {
    PAYMENT_MODE,
    CHARGEBACK_STATUS_ENUM,
    DISPUTE_STATUS_ENUM,
} from 'utils/constants/commonValues';

// actions
import {
    fetchChargeBackDataRequest,
    getActiveChargebackReportRequest,
    downloadChargebackReportRequest,
    generateChargebackReportError,
    generateChargebackReportRequest,
    resetRaiseChargebackForm,
} from './redux/chargeback.actions';

// libs
import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { useHistory } from 'react-router-dom';
import moment from 'moment';
import { getDefaultValues } from 'components/PageTable/MainTable';

const { Button } = FormElems;

const getColumns = ({ handleViewClick }) => [
    {
        header: 'Merchant Name',
        accessor: 'merchantName',
    },
    {
        header: 'Date',
        accessor: 'createdDate',
    },
    {
        header: 'Order ID',
        accessor: 'orderId',
    },
    {
        header: 'Payment Type',
        accessor: 'paymentType',
    },
    {
        header: 'Priority',
        // eslint-disable-next-line react/display-name
        render: (row, index) => {
            return (
                <div
                    key={`priority-${index}`}
                    className={`priority ${row.priority}`}
                >
                    {row.priority}
                </div>
            );
        },
    },
    {
        header: 'Status',
        accessor: 'chargebackStatus',
    },
    {
        header: 'Amount',
        accessor: 'amount',
    },
    {
        header: 'Dispute Type',
        accessor: 'type',
    },
    {
        header: 'Action',
        accessor: 'action',
        // eslint-disable-next-line react/display-name
        render: (row, index) => (
            <div
                key={`action-${index}`}
                className="chargeback-actions-botton"
                onClick={() => {
                    handleViewClick(row, index);
                }}
            >
                View
            </div>
        ),
    },
];

const getFilterConfiguration = () => [
    {
        name: 'search',
        type: 'TEXT',
        label: 'By RRN/Order ID/Dispute ID',
        placeholder: 'Search',
    },
    {
        name: 'dateRange',
        type: 'DATERANGE',
        label: 'By Date Range',
        startDate: moment()
            .subtract(1, 'days')
            .startOf('day'),
        endDate: moment().endOf('day'),
        defaultValue: {
            startDate: moment()
                .subtract(1, 'days')
                .startOf('day'),
            endDate: moment().endOf('day'),
        },
    },
    {
        name: 'paymentType',
        type: 'MULTISELECT',
        label: 'Payment Type',
        options: PAYMENT_MODE,
    },
    {
        name: 'statuses',
        type: 'MULTISELECT',
        label: 'Status',
        options:Object.values(CHARGEBACK_STATUS_ENUM).concat(Object.values(DISPUTE_STATUS_ENUM)),
    },
    // {
    //     name: 'types',
    //     type: 'MULTISELECT',
    //     label: 'Dispute Type',
    //     options: [
    //         { label: 'Dispute', value: 'DISPUTE' },
    //         { label: 'Chargeback', value: 'CHARGEBACK' },
    //     ],
    // },
    // {
    //     name: 'types',
    //     type: 'MULTISELECT',
    //     label: 'Status',
    //     options: Object.values(DISPUTE_STATUS_ENUM),
    // },
    // {
    //     name: 'types',
    //     type: 'MULTISELECT',
    //     label: 'Dispute Types',
    //     options: [
    //         { label: 'DISPUTE', value: 'DISPUTE' },
    //         { label: 'Chargeback', value: 'CHARGEBACK' },
    //     ],
    // },
];

const ChargebackPage = ({ chargebackData, auth, actions }) => {
    const {
        tableData,
        pagination,
        isLoading,
        activeReports,
        error,
    } = chargebackData;

    const history = useHistory();
    const [showDownload, setShowDownload] = useState(false);
    const [filterInfo, setFilterInfo] = useState({});

    const handleViewClick = (row, index) => {
        console.log(row.type , " row type consoling")
        if (row.type != 'UPI_DISPUTE') {
            history.push(`/chargeback/${row.chargebackId}/${row.orderId}/${row.type}`);
        } else {
            history.push(`/chargeback/dispute/${row.chargebackId}/${row.orderId}/${row.type}`);
        }
    };

    const fetchData = ({ pageSize, pageNumber, filterData }) => {
        actions.fetchChargeBackDataRequest({
            pageSize,
            pageNumber,
            filterData,
        });
        setFilterInfo(filterData);
    };

    return (
        <div className="chargeback-page-wrapper">
            <PageTable.MainTable
                tableHead={
                    <PageTable.TableHead
                        tableHeading="Dispute Resolution"
                        rightComponent={
                            <>
                                <Popup
                                    title="Download Status"
                                    showCloseIcon
                                    showOverlay
                                    showFilter={showDownload}
                                    closePopup={() => setShowDownload(false)}
                                >
                                    <ViewDownloadGeneric
                                        data={activeReports?.reports || []}
                                        downloadReportRequest={
                                            actions.downloadChargebackReportRequest
                                        }
                                        getActiveReportRequest={
                                            actions.getActiveChargebackReportRequest
                                        }
                                    />
                                </Popup>

                                <div className="table-additonal-actions">
                                    <Button
                                        buttonType="secondary"
                                        customClass="rounded-button secondary-rounded-button"
                                        text="Export Data"
                                        handleClick={() =>
                                            actions.generateChargebackReportRequest(
                                                {
                                                    reportFileName: `chargeback_${moment(
                                                        filterInfo.startDate
                                                    ).format(
                                                        'DDMMYYYY'
                                                    )}_${moment(
                                                        filterInfo.endDate
                                                    ).format('DDMMYYYY')}`,
                                                    ...filterInfo,
                                                }
                                            )
                                        }
                                    />
                                    <Button
                                        buttonType="secondary"
                                        customClass="rounded-button secondary-rounded-button"
                                        text="View Downloads"
                                        handleClick={() =>
                                            setShowDownload(true)
                                        }
                                    />
                                    <ChargebackComponents.RaiseChargeBackComponent
                                        onRaiseSuccess={() =>
                                            fetchData({
                                                pageSize: 10,
                                                pageNumber: 1,
                                                filterData : getDefaultValues(getFilterConfiguration()),
                                            })
                                        }
                                        resetRaiseChargebackForm={
                                            actions.resetRaiseChargebackForm
                                        }
                                    />
                                </div>
                            </>
                        }
                    />
                }
                columns={getColumns({
                    handleViewClick,
                })}
                tableData={tableData}
                fetchData={fetchData}
                pagination={pagination}
                isLoading={isLoading}
                isPaginationEnabled
                error={error && error.errorMessage}
                noDataError={{
                    message: 'No chargebacks yet!',
                    subtitle: 'Chargebacks will be visible here',
                    imageSrc: happyFaceImage,
                }}
                filters={getFilterConfiguration()}
            />
        </div>
    );
};

// PropType validation for Chargeback component
ChargebackPage.propTypes = {
    actions: PropTypes.object,
    auth: PropTypes.object,
    chargebackData: PropTypes.object,
};

const mapStateToProps = ({ auth, chargebackData }) => ({
    auth,
    chargebackData,
});
const mapDispatchToProps = dispatch => ({
    actions: bindActionCreators(
        {
            fetchChargeBackDataRequest,
            getActiveChargebackReportRequest,
            downloadChargebackReportRequest,
            generateChargebackReportError,
            generateChargebackReportRequest,
            resetRaiseChargebackForm,
        },
        dispatch
    ),
});

export default connect(mapStateToProps, mapDispatchToProps)(ChargebackPage);
